/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Enrolment } from '../../models/enrolment';

export interface ApiEnrolmentByExternalIdExternalIdGet$Params {
  external_id: string;
}

export function apiEnrolmentByExternalIdExternalIdGet(http: HttpClient, rootUrl: string, params: ApiEnrolmentByExternalIdExternalIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Enrolment>> {
  const rb = new RequestBuilder(rootUrl, apiEnrolmentByExternalIdExternalIdGet.PATH, 'get');
  if (params) {
    rb.path('external_id', params.external_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Enrolment>;
    })
  );
}

apiEnrolmentByExternalIdExternalIdGet.PATH = '/api/enrolment/by-external-id/{external_id}';
